import React from 'react';
import FilterModal from './filter-modal';
import { PAGE_VARIANT } from '../constants';
import { DfFilterProvider } from '../context/filter/df-filter-provider';
import { useDfContext } from '../context/df-context';

export default function SearchFilter({
  label,
  variant,
}: {
  label: string;
  variant: string;
}): React.ReactElement {
  const [modalOpen, setModalOpen] = React.useState(false);
  const { state, updateState } = useDfContext();

  return (
    <>
      <button className="df-btn df-btn--grey df-open-filters" onClick={() => setModalOpen(true)}>
        {label}
        <span className="df-btn__icon-right df-icon-filter_white" />
      </button>
      {variant === PAGE_VARIANT.RESULT ? (
        <DfFilterProvider open={modalOpen} appState={state} dispatchState={updateState}>
          <FilterModal
            visible={modalOpen}
            handleClose={() => setModalOpen(false)}
            variant={variant}
          />
        </DfFilterProvider>
      ) : (
        <FilterModal
          visible={modalOpen}
          handleClose={() => setModalOpen(false)}
          variant={variant}
        />
      )}
    </>
  );
}
